import React, { useCallback } from 'react'
import {
  SocketContextProvider as ChuckSocketContextProvider,
  useSocketMessageListener
} from '@gopeerproject/chuck'
import { ActionTypes } from '../constants'
import { useDispatch } from 'react-redux'
import { useQueryClient } from 'react-query'
import pick from 'lodash.pick'

const useRealtimeUpdates = () => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()

  const createOrUpdateFile = useCallback(
    (payload) => {
      dispatch({
        type: ActionTypes.LOAD_FILE.SUCCESS,
        payload
      })
    },
    [dispatch]
  )

  const deleteFile = useCallback(
    (payload) => {
      dispatch({
        type: ActionTypes.DELETE_FILE.SUCCESS,
        payload
      })
    },
    [dispatch]
  )

  const onAppointmentUpdate = useCallback(
    (payload) =>
      queryClient.setQueryData(['classrooms', payload.id], (prevState) => ({
        ...prevState,
        ...pick(payload, ['overtime', 'duration', 'status', 'twilioRoom'])
      })),
    [queryClient]
  )

  useSocketMessageListener('create:file', createOrUpdateFile)
  useSocketMessageListener('update:file', createOrUpdateFile)
  useSocketMessageListener('delete:file', deleteFile)
  useSocketMessageListener('update:appointment', onAppointmentUpdate)
}

const RealtimeFileUpdatesProvider = ({ children }) => {
  useRealtimeUpdates()
  return children
}

export const SocketContextProvider = ({ children }) => {
  return (
    <ChuckSocketContextProvider url={process.env.SOCKET_URL}>
      <RealtimeFileUpdatesProvider>{children}</RealtimeFileUpdatesProvider>
    </ChuckSocketContextProvider>
  )
}
